import { immutableSplice } from '../utils/array';
import {
  CheckVehicles,
  DropdownField,
  Task,
} from '../views/pages/ControllerTask/BCResult/BCResult.types';
import React, { Dispatch, SetStateAction } from 'react';
import { Styled } from '../views/pages/ControllerTask/BCResult/BCResult.styles';
import ItemsPicker from '../views/components/UI/ItemsPicker';
import { IDropdownOption } from 'office-ui-fabric-react';

export const useBcResultUtilities = (
  setResultTask: Dispatch<SetStateAction<Task | null>>,
  vehicles: number[],
  routes: string[]
) => {
  function parseValue(value: string | undefined, saveAsNumber: true): number;
  function parseValue(
    value: string | undefined,
    saveAsNumber?: false | undefined
  ): string;
  function parseValue(value: string | undefined, saveAsNumber?: boolean) {
    let parsedValue = parseInt(value || '0');
    parsedValue =
      parsedValue < 0 || Number.isNaN(parsedValue) ? 0 : parsedValue;
    return saveAsNumber ? parsedValue : `${parsedValue}`;
  }

  const onChangeTicketItem = (
    field: 'sell_tickets' | 'take_tickets',
    ticketIndex: number,
    value: number,
    editingVehicleIndex: number
  ) => {
    setResultTask((prev) => {
      if (!prev) return null;
      const prevItem = prev.check_vehicles[editingVehicleIndex];
      if (field === 'sell_tickets') {
        const relativeTicket =
          prev.check_tickets[prevItem[field][ticketIndex].ticket_id];
        const sumOfOtherStrings = prev.check_vehicles.reduce(
          (res, cur, stringIndex) => {
            if (editingVehicleIndex === stringIndex) return res;
            return res + cur[field][ticketIndex].count;
          },
          0
        );

        if (value + sumOfOtherStrings >= relativeTicket) {
          value = relativeTicket - sumOfOtherStrings;
        }
      }
      const updatedTicketList = immutableSplice(
        prevItem[field],
        ticketIndex,
        1,
        {
          ...prevItem[field][ticketIndex],
          count: Number(value),
        }
      );
      const updatedList = immutableSplice<any>(
        prev.check_vehicles,
        editingVehicleIndex,
        1,
        {
          ...prevItem,
          [field]: updatedTicketList,
        }
      );
      return {
        ...prev,
        check_vehicles: updatedList,
      };
    });
  };

  const onChange = (
    field: keyof CheckVehicles,
    value: string,
    editingVehicleIndex: number,
    convertToNumber?: boolean
  ) => {
    setResultTask((prev) => {
      if (!prev) return null;
      const prevItem = prev.check_vehicles[editingVehicleIndex];
      const updatedList = immutableSplice<any>(
        prev.check_vehicles,
        editingVehicleIndex,
        1,
        {
          ...prevItem,
          [field]: convertToNumber ? Number(value) : value,
        }
      );
      return {
        ...prev,
        check_vehicles: updatedList,
      };
    });
  };

  const getOptions = (name: DropdownField): IDropdownOption[] => {
    if (name === 'depot_number')
      return vehicles.map((id) => ({
        key: id,
        text: `${id}`,
      }));
    return routes
      .map((short_name) => ({
        text: short_name,
        key: short_name,
      }))
      .sort((a, b) => {
        return a.text.length - b.text.length === 0
          ? (a.text.localeCompare(b.text))
          : a.text.length - b.text.length;
      });
  };

  const getDropdown = (
    name: DropdownField,
    vehicle: CheckVehicles,
    editingVehicleIndex: number
  ) => {
    return (
      <ItemsPicker
        fieldName=""
        options={getOptions(name)}
        value={vehicle[name] || null}
        onChange={(_, option) => {
          onChange(name, option as string, editingVehicleIndex);
        }}
      />
    );
  };

  return { parseValue, onChangeTicketItem, getDropdown };
};
